import Grid from 'components/Grid';
import Rating from 'components/Rating';
import ReviewSnippet from 'components/Review/components/Snippet';
import Typography from 'components/Typography';

import classes from './UserOpinions.module.scss';

const UserOpinions = ({ reviews, productName }) => {
  const snippets = reviews.snippets.slice(0, 2);

  return (
    <div className="ReviewSnippets">
      <Typography
        component="h2"
        className={classes.title}
      >{`User opinions about ${productName} price and value`}</Typography>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12} className={classes.valueForMoneyContainer}>
          <Typography variant="body-sm">Value for money rating:</Typography>
          <Rating.Link
            average={reviews.by_field.rating_value.toString()}
            totals={reviews.total}
            isCompact={true}
            size="small"
          />
        </Grid>
        {!!snippets.length && (
          <Grid item={true} xs={12}>
            <Typography variant="body-sm">
              {`To see what individual users think of ${productName}'s price and value, check out the review snippets below.`}
            </Typography>
          </Grid>
        )}
        {snippets.map((x, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item={true} xs={12} sm={6} lg={4} key={`snippet-${i}`}>
            <div className={classes.snippetContainer}>
              <ReviewSnippet
                size="large"
                type={x.type}
                snippet={x}
                key={x.text}
                writeReview={true}
                engagementComponent="user-opinions-pricing"
              />
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
export default UserOpinions;
